import Filters from "./Filters/Filters.jsx";
import Product from "./Product/Product.jsx";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSaleProducts } from "../../../redux/saleProductActions";
import style from "./SalesCatalogue.module.css";

const SalesCatalogue = () => {

    const dispatch = useDispatch();
    const saleProductsCopy = useSelector(state => state.saleProducts.saleProductsCopy);

    useEffect(() => {
        dispatch(getSaleProducts());
    }, [dispatch]);

    //----- PAGINADO

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const [paginatedProducts, setPaginatedProducts] = useState([]);

    useEffect(() => {
        if (Array.isArray(saleProductsCopy)) {
            const newPageData = saleProductsCopy.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
            );

            setPaginatedProducts((prev) => {
                const prevStringified = JSON.stringify(prev);
                const newStringified = JSON.stringify(newPageData);

                return prevStringified === newStringified ? prev : newPageData;
            });
        }
    }, [saleProductsCopy, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(saleProductsCopy.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const getPageButtons = () => {
        const buttons = [];
        let startPage, endPage;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`pageButton ${currentPage === i ? 'currentPage' : ''}`}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };

    return(
        <div className={style.div}>
            <h2>Productos en <span>oferta</span></h2>
            <h4>Precio contado hasta agotar stock</h4>

            <Filters/>
            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>

            <div className={style.cards}>
                {paginatedProducts.map(saleProduct => (
                    <div className={style.card}>
                        <Product
                            key={saleProduct.id}
                            id={saleProduct.id}
                            brand={saleProduct.brand}
                            category={saleProduct.category}
                            price={saleProduct.price}
                            image={saleProduct.image}
                            description={saleProduct.description}
                        />
                    </div>
                ))}
            </div>

            <div className="paginationContainer">
                <div className="pagination">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        ◂
                    </button>
                    {getPageButtons()}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        ▸
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SalesCatalogue;